exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header[data-v-575d4d6f] {\n  background-color: inherit !important;\n  border-bottom: none !important;\n}\n.field-height[data-v-575d4d6f] {\n  min-height: 37px;\n  max-height: 37px;\n  border: 1px solid #b0b9bf;\n}\n.btn-light-red[data-v-575d4d6f] {\n  background: #f87676;\n}\n", ""]);

// exports
